import { render, staticRenderFns } from "./WesQuestionNumber.vue?vue&type=template&id=3ae6a79c&scoped=true&"
import script from "./WesQuestionNumber.vue?vue&type=script&lang=js&"
export * from "./WesQuestionNumber.vue?vue&type=script&lang=js&"
import style0 from "./WesQuestionNumber.vue?vue&type=style&index=0&id=3ae6a79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6a79c",
  null
  
)

export default component.exports